var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSmallRightBlue50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24x24/ArrowSmall_Right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24x24/ArrowSmall_Right",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4142136,11 L15.7071068,15.2928932 C16.0976311,15.6834175 16.0976311,16.3165825 15.7071068,16.7071068 C15.3165825,17.0976311 14.6834175,17.0976311 14.2928932,16.7071068 L9.29289322,11.7071068 C8.90236893,11.3165825 8.90236893,10.6834175 9.29289322,10.2928932 L14.2928932,5.29289322 C14.6834175,4.90236893 15.3165825,4.90236893 15.7071068,5.29289322 C16.0976311,5.68341751 16.0976311,6.31658249 15.7071068,6.70710678 L11.4142136,11 Z",
    id: "05.-Arrow-right",
    fill: "#0067df",
    transform: "translate(12.500000, 11.000000) scale(-1, 1) translate(-12.500000, -11.000000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallRightBlue50);
export default __webpack_public_path__ + "static/media/ArrowSmall_Right_Blue50.f78faa256624db64f378f8226f1c1c19.svg";
export { ForwardRef as ReactComponent };